import { Resource } from '@websolutespa/payload-utils';

export const translations: Resource = {
  en: {
    group: {
      llm: 'LLM',
    },
    collection: {
      singular: {
        llmApp: 'Application',
        llmTool: 'Tool',
        llmAppTool: 'Tool',
        llmThread: 'Thread',
        llmHistory: 'History',
        llmFineTuning: 'Fine Tuning',
        llmKbAzure: 'Azure',
        llmKbConfluence: 'Confluence',
        llmKbDropbox: 'Dropbox',
        llmKbGcs: 'Google cloud storage',
        llmKbGithub: 'Github',
        llmKbGoogledrive: 'Google drive',
        llmKbFile: 'Knowledgebase file',
        llmKbJira: 'Jira',
        llmPrompt: 'Mental model',
        llmKbS3: 'S3',
        llmKbSftp: 'SFTP',
        llmKbSharepoint: 'Sharepoint',
        llmKbSharepointCustom: 'Sharepoint Custom',
        llmKbSitemap: 'Sitemap',
        llmKbSlack: 'Slack',
        llmRule: 'Rule',
        llmUserUpload: 'User upload',
        llmVectorDb: 'Vector DB',
        card: 'Card',
        cta: 'Call to action',
        llmKbThron: 'Thron',
        llmKbShopify: 'Shopify',
        llmKbApi: 'API',
        llmKbZendesk: 'Zendesk',
      },
      plural: {
        llmApp: 'Applications',
        llmTool: 'Tools',
        llmAppTool: 'Tools',
        llmThread: 'Threads',
        llmHistory: 'History',
        llmFineTuning: 'Fine Tuning',
        llmKbAzure: 'Azure',
        llmKbConfluence: 'Confluence',
        llmKbDropbox: 'Dropbox',
        llmKbGcs: 'Google cloud storage',
        llmKbGithub: 'Github',
        llmKbGoogledrive: 'Google drive',
        llmKbFile: 'Knowledgebase files',
        llmKbJira: 'Jira',
        llmPrompt: 'Mental models',
        llmKbS3: 'S3',
        llmKbSftp: 'SFTP',
        llmKbSharepoint: 'Sharepoint',
        llmKbSharepointCustom: 'Sharepoint Custom',
        llmKbSitemap: 'Sitemaps',
        llmKbSlack: 'Slack',
        llmRule: 'Rules',
        llmUserUpload: 'User uploads',
        llmVectorDb: 'Vector DBs',
        card: 'Cards',
        cta: 'Call to action',
        llmKbThron: 'Thron',
        llmKbShopify: 'Shopify',
        llmKbApi: 'API',
        llmKbZendesk: 'Zendesk',
      },
    },
    global: {
    },
    description: {
      __from_env: 'Inserisci la variabile d\'ambiente (es. JIRA_CONFIG).',
      __from_file: 'Inserisci il percorso del file JSON (es. /opt/configs/jira_config.json).',
      confluence_password: 'Confluence password or Cloud API token, if filled, set the access_token to None and vice versa.',
      confluence_accessToken: 'The personal access token for authenticating with Confluence, e.g., \'AT....\'',
      confluence_url: 'The URL of the Confluence instance, e.g., \'https://example.atlassian.net\'.',
      confluence_userEmail: 'The email address or username of the Confluence user',
      confluence_spaces: 'A list of Confluence spaces to interact with, e.g., [\'SPACE1\', \'SPACE2\'].',
      confluence_maxNumOfDocsFromEachSpace: 'The maximum number of documents to fetch from each specified space. Defaults to 500, with a range of 1 to 5000.',
      confluence_extension: 'A list of file extensions to filter by. Defaults to None, e.g., [\'.pdf\', \'.docx\'].',
      confluence_CQL_filter: 'An optional CQL (Confluence Query Language) filter to refine the document retrieval process. Es: type = \'page\' AND status = \'Verified\'',
      jira_JQL_filter: 'An optional JQL (Jira Query Language) filter to refine the issue retrieval process. E.g.: created >= -30d AND priority = High',
    },
    field: {
      __from_env: 'Variabile d\'ambiente (__from_env)',
      __from_file: 'File di configurazione (__from_file)',
      accessToken: 'Access token',
      accountKey: 'Account key',
      accountName: 'Account name',
      answer: 'Answer',
      apiKey: 'API key',
      appKey: 'App key',
      appTool: 'App tool',
      boards: 'Boards',
      body: 'Body',
      branch: 'Branch',
      channels: 'Channels',
      clientId: 'Client ID',
      clientSecret: 'Client secret',
      columnName: 'Column name',
      columnValues: 'Column values',
      configSource: 'Modalità configurazione',
      connectionString: 'DB connection string',
      createdAt: 'Created at',
      credentials: 'Credentials',
      dataSource: 'Data source',
      dbSettings: 'DB settings',
      deletedFields: 'Deleted fields',
      destName: 'Dest Name',
      driveId: 'Drive ID',
      endpointUrl: 'Endpoint URL',
      excludeClass: 'Exclude class',
      excludeId: 'Exclude ID',
      excludeTag: 'Exclude tag',
      extension: 'Extension',
      externalEndpoints: 'External endpoints',
      feedback: 'Feedback',
      fieldsMapping: 'Fields mapping',
      filterUrls: 'Filter URLs',
      functionId: 'LLM functionId',
      functionName: 'LLM functionName',
      functionDescription: 'LLM functionDescription',
      functionSettings: 'Function settings',
      files: 'Files',
      host: 'Host',
      httpReferrers: 'HTTP referrers',
      key: 'Key',
      icon: 'Icon',
      includeOnlySelector: 'Include only selector',
      issues: 'Issues',
      knowledgeBase: 'Knowledge base',
      knowledgeBaseEndpoints: 'Endpoints import knowledge base',
      knowledgebaseSettings: 'Knowledge base settings',
      llmApp: 'LLM App',
      llmConfig: 'LLM Config',
      llmChainSettings: 'LLM chain settings',
      message: 'Message',
      messageId: 'Message ID',
      mode: 'Mode',
      model: 'Model',
      nightlyKbGeneration: 'Nightly KB generation',
      notes: 'Notes',
      newFields: 'New fields',
      numDays: 'Number of days',
      openAIApiKey: 'OpenAI ApiKey',
      outputFormat: 'Output format',
      port: 'Port',
      projects: 'Projects',
      prompt: 'Mental model',
      question: 'Question',
      rating: 'Rating',
      recursive: 'Recursive',
      remoteUrl: 'Remote URL',
      replacedFields: 'Replaced fields',
      repo: 'Repository',
      role: 'Role',
      sasToken: 'SAS token',
      secret: 'Secret',
      secretId: 'Secret ID',
      secrets: 'secrets',
      secretValue: 'Secret Value',
      serviceAccountKey: 'Service account key',
      siteId: 'Site ID',
      sitemapUrl: 'Sitemap URL',
      restrictDomain: 'Restrict domain',
      spaces: 'Spaces',
      maxNumOfDocsFromEachSpace: 'Max number of docs from each space',
      srcName: 'Source name',
      systemMessage: 'systemMessage',
      tenantId: 'Tenant ID',
      token: 'Token',
      tools: 'Tools',
      userEmail: 'User email',
      username: 'Username',
      value: 'Value',
      vectorDbFile: 'Vector DB file',
      waitingMessage: 'Waiting Message',
      previewEnabled: 'Enable Preview',
      sharepointSettings: 'Sharepoint settings',
      tagsToInclude: 'Tags to include',
      tagsToExclude: 'Tags to exclude',
      fileExtToExclude: 'File extensions to exclude',
      fileExt: 'File extensions to exclude',
      metaFields: 'Metadata filters',
      threshold: 'Threshold',
      shopName: 'Shop name',
      graphqlQuery: 'GraphQL query',
      attributeFields: 'Attribute fields',
      organizationName: 'Organization name',
      filterHandle: 'Exclude by handle',
      cqlFilter: 'CQL filter',
      subdomain: 'Subdomain',
      email: 'Email',
      itemType: 'Item type',
    },
    general: {
      emptyLlmAppLinks: 'No links configured for the app',
      generateKb: 'Generate knowledgebase',
      generatingKb: 'Generating knowledgebase...',
      generateKbSuccess: 'Knowledgebase generated successfully',
      generateKbError: 'There was an error while generating the knowledgebase',
      generateRules: 'Generate rules',
      generatingRules: 'Generating rules...',
      generateRulesSuccess: 'Rules generated successfully',
      generateRulesError: 'Error generating rules',
      kbFileNoToolOption: 'None: file is associated with app',
      generateKbAppOnly: 'App only',
      generateKbToolsOnly: 'Tools only',
      generateKbAppAndTools: 'Both app and tools',
      generateKbSpecificTool: 'Specific tool',
      generateKbModalTitle: 'Generate knowledgebase',
      generateRulesModalTitle: 'Generate rules',
      selectLlmApp: 'Select the app for which to generate the knowledgebase',
      selectKbGenerationMode: 'Select the knowledgebase generation mode',
      selectApp: 'Select app',
      selectTool: 'Select tool',
      bulkUpload: 'Bulk Upload',
      bulkUploadTitle: 'Bulk Upload KB Files',
      bulkUploadUploading: 'Uploading files...',
      bulkUploadSuccess: 'All files uploaded successfully',
      bulkUploadPartial: 'Some files failed to upload',
      bulkUploadError: 'Error during bulk upload',
      selectFiles: 'Select files',
      removeFile: 'Remove',
      noFilesSelected: 'No files selected',
      filesSelected: 'files selected',
    },
  },
  it: {
    group: {
      llm: 'LLM',
    },
    collection: {
      singular: {
        llmApp: 'Applicazione',
        llmTool: 'Tool',
        llmAppTool: 'Tool',
        llmThread: 'Thread',
        llmHistory: 'History',
        llmFineTuning: 'Fine Tuning',
        llmKbAzure: 'Azure',
        llmKbConfluence: 'Confluence',
        llmKbDropbox: 'Dropbox',
        llmKbGcs: 'Google cloud storage',
        llmKbFile: 'Knowledgebase file',
        llmKbGithub: 'Github',
        llmKbGoogledrive: 'Google drive',
        llmKbJira: 'Jira',
        llmPrompt: 'Mental model',
        llmKbS3: 'S3',
        llmKbSftp: 'SFTP',
        llmKbSharepoint: 'Sharepoint',
        llmKbSharepointCustom: 'Sharepoint Custom',
        llmKbSitemap: 'Sitemap',
        llmKbSlack: 'Slack',
        llmRule: 'Rule',
        llmUserUpload: 'Upload utente',
        llmVectorDb: 'Vector DB',
        card: 'Card',
        cta: 'Call to action',
        llmKbThron: 'Thron',
        llmKbShopify: 'Shopify',
        llmKbZendesk: 'Zendesk',
      },
      plural: {
        llmApp: 'Applicazioni',
        llmTool: 'Tools',
        llmAppTool: 'Tools',
        llmThread: 'Threads',
        llmHistory: 'History',
        llmFineTuning: 'Fine Tuning',
        llmKbAzure: 'Azure',
        llmKbConfluence: 'Confluence',
        llmKbDropbox: 'Dropbox',
        llmKbGcs: 'Google cloud storage',
        llmKbFile: 'Knowledgebase file',
        llmKbGithub: 'Github',
        llmKbGoogledrive: 'Google drive',
        llmKbJira: 'Jira',
        llmPrompt: 'Mental models',
        llmKbS3: 'S3',
        llmKbSftp: 'SFTP',
        llmKbSharepoint: 'Sharepoint',
        llmKbSharepointCustom: 'Sharepoint Custom',
        llmKbSitemap: 'Sitemap',
        llmKbSlack: 'Slack',
        llmRule: 'Rules',
        llmUserUpload: 'Upload utente',
        llmVectorDb: 'Vector DBs',
        card: 'Cards',
        cta: 'Call to action',
        llmKbThron: 'Thron',
        llmKbShopify: 'Shopify',
        llmKbZendesk: 'Zendesk',
      },
    },
    global: {
    },
    description: {
      __from_env: 'Inserisci la variabile d\'ambiente (es. JIRA_CONFIG).',
      __from_file: 'Inserisci il percorso del file JSON (es. /opt/configs/jira_config.json).',
      confluence_password: 'Password di Confluence o token API Cloud, se compilato, impostare l\'access_token su Nessuno e viceversa',
      confluence_accessToken: 'Il token di accesso personale per l\'autenticazione con Confluence, ad esempio, \'AT....\'',
      confluence_url: 'L\'URL dell\'istanza di Confluence, ad esempio, \'https://example.atlassian.net\'',
      confluence_userEmail: 'L\'indirizzo e-mail o il nome utente dell\'utente di Confluence',
      confluence_spaces: 'Un elenco di spazi Confluence con cui interagire, ad esempio [\'SPACE1\', \'SPACE2\']',
      confluence_maxNumOfDocsFromEachSpace: 'Il numero massimo di documenti da recuperare da ciascuno spazio specificato. Il valore predefinito è 500, con un intervallo da 1 a 5000.',
      confluence_extension: 'Un elenco di estensioni di file da filtrare. Si imposta come nessuno, ad esempio [\'.pdf\', \'.docx\'].',
      confluence_CQL_filter: 'Un filtro CQL (Confluence Query Language) opzionale per affinare il processo di recupero dei documenti, es: type = \'page\' AND status = \'Verified\'',
      jira_JQL_filter: 'Un filtro JQL (Jira Query Language) opzionale per affinare il processo di recupero delle issue, es: created >= -30d AND priority = High',
    },
    field: {
      __from_env: 'Variabile d\'ambiente (__from_env)',
      __from_file: 'File di configurazione (__from_file)',
      accessToken: 'Access token',
      accountKey: 'Account key',
      accountName: 'Account name',
      answer: 'Risposta',
      apiKey: 'API key',
      appKey: 'App key',
      appTool: 'App tool',
      boards: 'Boards',
      body: 'Corpo',
      branch: 'Branch',
      channels: 'Channels',
      clientId: 'Client ID',
      clientSecret: 'Client secret',
      columnName: 'Nome colonna',
      columnValues: 'Valori colonna',
      'description.config__from_env_description': 'Inserisci la variabile d\'ambiente (es. JIRA_CONFIG).',
      config__from_file_description: 'Inserisci il percorso del file JSON (es. /opt/configs/jira_config.json).',
      configSource: 'Modalità configurazione',
      connectionString: 'Stringa di connessione al DB',
      createdAt: 'Creato il',
      credentials: 'Credenziali',
      dataSource: 'Sorgente dati',
      dbSettings: 'DB Settings',
      deletedFields: 'Campi eliminati',
      destName: 'Nome destinazione',
      driveId: 'Drive ID',
      endpointUrl: 'Endpoint URL',
      excludeClass: 'Escludi classi',
      excludeId: 'Escludi ID',
      excludeTag: 'Escludi tag',
      extension: 'Estensioni',
      externalEndpoints: 'Endpoint esterni',
      feedback: 'Feedback',
      fieldsMapping: 'Fields mapping',
      files: 'Files',
      filterUrls: 'Filtro URLs',
      functionId: 'LLM functionId',
      functionName: 'LLM functionName',
      functionDescription: 'LLM functionDescription',
      functionSettings: 'Function settings',
      host: 'Host',
      httpReferrers: 'HTTP referrers',
      key: 'Key',
      icon: 'Icona',
      includeOnlySelector: 'Includi solo selettori',
      issues: 'Issues',
      knowledgeBase: 'Knowledge base',
      knowledgeBaseEndpoints: 'Endpoints import knowledge base',
      knowledgebaseSettings: 'Knowledge base settings',
      llmApp: 'LLM App',
      llmConfig: 'LLM Config',
      llmChainSettings: 'Impostazioni LLM chain',
      message: 'Message',
      messageId: 'ID messaggio',
      mode: 'Modalità',
      model: 'Model',
      nightlyKbGeneration: 'Generazione KB notturna',
      notes: 'Note',
      newFields: 'Nuovi campi',
      numDays: 'Numero di giorni',
      openAIApiKey: 'OpenAI ApiKey',
      outputFormat: 'Formato output',
      port: 'Port',
      projects: 'Progetti',
      prompt: 'Mental model',
      question: 'Domanda',
      rating: 'Rating',
      recursive: 'Ricorsivo',
      remoteUrl: 'URL remoto',
      replacedFields: 'Campi sostituiti',
      repo: 'Repository',
      role: 'Role',
      sasToken: 'SAS token',
      secret: 'Secret',
      secretId: 'Secret ID',
      secrets: 'secrets',
      secretValue: 'Secret Value',
      serviceAccountKey: 'Service account key',
      siteId: 'Site ID',
      sitemapUrl: 'Sitemap URL',
      restrictDomain: 'Limita dominio',
      spaces: 'Spaces',
      maxNumOfDocsFromEachSpace: 'Numero massimo di documenti per space',
      srcName: 'Nome sorgente',
      systemMessage: 'systemMessage',
      tenantId: 'Tenant ID',
      token: 'Token',
      tools: 'Tools',
      userEmail: 'User email',
      username: 'Username',
      value: 'Valore',
      vectorDbFile: 'Vector DB File',
      waitingMessage: 'Waiting Message',
      previewEnabled: 'Abilita Preview',
      sharepointSettings: 'Impostazioni Sharepoint',
      tagsToInclude: 'Tags da includere',
      tagsToExclude: 'Tags da escludere',
      fileExtToExclude: 'Estensioni file da escludere',
      fileExt: 'File extensions to exclude',
      metaFields: 'Filtro metadati',
      threshold: 'Threshold',
      attributeFields: 'Attributi',
      graphqlQuery: 'GraphQL query',
      organizationName: 'Nome organizzazione',
      shopName: 'Nome negozio',
      filterHandle: 'Escludi da handle',
      cqlFilter: 'Filtro CQL',
      subdomain: 'Sottodominio (Subdomain)',
      email: 'Email account',
      itemType: 'Tipo elemento',
    },
    general: {
      emptyLlmAppLinks: 'Nessun link configurato per l\'app',
      generateKb: 'Genera knowledgebase',
      generatingKb: 'Generazione knowledgebase in corso...',
      generateKbSuccess: 'Knowledgebase generata con successo',
      generateKbError: 'Errore durante la generazione della knowledgebase',
      generateRules: 'Genera rules',
      generatingRules: 'Generazione rules in corso...',
      generateRulesSuccess: 'Rules generate con successo',
      generateRulesError: 'Errore durante la generazione delle rules',
      kbFileNoToolOption: 'Nessuno: il file è associato all\'app',
      generateKbAppOnly: 'Solo app',
      generateKbToolsOnly: 'Solo tools',
      generateKbAppAndTools: 'App e tools',
      generateKbSpecificTool: 'Tool specifico',
      generateKbModalTitle: 'Genera knowledgebase',
      generateRulesModalTitle: 'Genera rules',
      selectLlmApp: 'Seleziona l\'app per la quale generare la knowledgebase',
      selectKbGenerationMode: 'Seleziona la modalità di generazione della knowledgebase',
      selectApp: 'Seleziona app',
      selectTool: 'Seleziona tool',
      bulkUpload: 'Caricamento multiplo',
      bulkUploadTitle: 'Caricamento multiplo file KB',
      bulkUploadUploading: 'Caricamento file in corso...',
      bulkUploadSuccess: 'Tutti i file caricati con successo',
      bulkUploadPartial: 'Alcuni file non sono stati caricati',
      bulkUploadError: 'Errore durante il caricamento multiplo',
      selectFiles: 'Seleziona file',
      removeFile: 'Rimuovi',
      noFilesSelected: 'Nessun file selezionato',
      filesSelected: 'file selezionati',
    },
  },
};
